import GrantService from '../../services/GrantService';
import grantUseCase from './grantUseCase';

const grantFactory = grantUseCase({
  GrantService: GrantService(),
});

export default grantFactory;
